module.exports = __webpack_public_path__ + "static/media/blue-filled-chevron-down.43eb4cc0.svg";